<template>
  <div :class="selectClass" @mouseleave="dropdown = false" @mouseover="mouseoverDropdown()">
    <label
      v-if="title != '' && !fillWidth"
      :for="'select-' + id"

      >{{ title }}</label
    >
    <input v-if="small == false"
      class="input"
      type="text"
      v-model="searchValue"
      :disabled="disabled"
      :placeholder="'Zoek naar ' + title.toLowerCase()"
      @focus="inputFocus = true"
      @blur="inputFocus = false"
    />
    <transition name="fade" mode="in-out">
      <div v-if="dropdown == true && small == false" class="dropdown">
        <div v-if="searchValue != '' && (searchOptions.length > 0 || searchData.length > 0)"  class="dropdown-item disabled">Zoekresultaten op {{ searchValue }}...</div>
        <div v-if="searchOptions.length == 0 && searchData.length == 0" class="dropdown-item disabled">Geen zoekresultaten op {{ searchValue }}...</div>
        <div v-if ="selectedOptionsModel == item" v-for="(item, key) in searchOptions" class="dropdown-item selected">{{ item }} &#10003;</div>
        <div v-if="selectedOptionsModel != item" v-for="(item, key) in searchOptions" class="dropdown-item" @click="selectedOptionsModel = item">{{ item }}</div>
        
        <div v-if ="selectedDataModel == item" v-for="(item, key) in searchData" class="dropdown-item selected">{{ item.label }} &#10003;</div>
        <div v-if="!item.disabled && selectedDataModel != item" v-for="(item, key) in searchData" class="dropdown-item" @click="selectedDataModel = item">{{ item.label }}</div>
        <div v-if ="item.disabled && selectedDataModel != item" v-for="(item, key) in searchData" class="dropdown-item disabled">{{ item.label }}</div>
      </div>
    </transition>
    <dean-icon
      v-if="small == false"
      class="search-icon"
      :glyph="search"
      :height="20"
      @click.native="updateSearch"
    ></dean-icon>
    <!-- OPTIONS -->
    <select
      v-if="options.length > 0"
      :class="selectedOptionsClass"
      :id="'select-' + id"
      :title="id"
      v-model="selectedOptionsModel"
      :disabled="disabled"
    >
      <option v-if="searchValue != '' && searchOptions.length < 1" :value="selectedOptionsModel" disabled>Geen zoekresultaten op {{ searchValue }}...</option>
      <option v-if="searchValue != '' && searchOptions.length > 0" value="" disabled>Zoekresultaten op {{ searchValue }}...</option>
      <option v-if="searchValue == ''" value="" disabled>Selecteer {{ title.toLowerCase() }}...</option>
      <option v-for="(item, key) in searchOptions" :value="item" :key="key">{{
        item
      }}</option>
    </select>

    <!-- DATA -->
    <label
      v-if="(selectedDataModel != null || selectedOptionsModel != '') && fillWidth"
      :for="'select-' + id"
      >{{ title }}</label
    >
    <select
      v-if="data.length > 0"
      :class="selectedDataClass"
      :id="'select-' + id"
      :title="id"
      v-model="selectedDataModel"
      :disabled="disabled"
    >
      <option v-if="searchValue != '' && searchData.length < 1" :value="selectedDataModel" disabled>Geen zoekresultaten op {{ searchValue }}...</option>
      <option v-if="searchValue != '' && searchData.length > 0" :value="null" disabled>Zoekresultaten op {{ searchValue }}...</option>
      <option v-if="searchValue == ''" :value="null" disabled
        >Selecteer {{ title.toLowerCase() }}...</option
      >
      <option
        v-for="(item, key) in searchData"
        :value="item"
        :key="key"
        :disabled="item.disabled"
        >{{ item.label }}</option
      >
    </select>

    <!-- EMPTY -->
    <select
      v-if="!data && !options"
      :class="selectedDataClass"
      :id="'select-' + id"
      :title="id"
      v-model="selectedData"
      :disabled="disabled"
    >
      <option :value="null" disabled
        >Selecteer {{ title.toLowerCase() }}...</option
      >
    </select>
  </div>
</template>

<script lang="ts">
// VUE
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

// SVG
import search from '../svg/feather-icons/search.svg';

// COMPONENTS
import deanIcon from './deanIcon.vue';
import deanTooltip from './deanTooltip.vue';

// COMPONENTS
@Component({
  components: {
    deanIcon,
    deanTooltip
  }
})
export default class deanInputSelect extends Vue {
  // PROPS
  @Prop({ default: () => {
      return [] 
  }}) options!: Array<any>;
  @Prop({ default: () => {
      return [] 
  }}) data!: Array<any>;
  @Prop({ default: '' }) title!: string;
  @Prop({ default: 'deanInputSelect' }) id!: string;
  @Prop({ default: false }) small!: boolean;
  @Prop({ default: false }) number!: boolean;
  @Prop({ default: false }) fillWidth!: boolean;
  @Prop({ default: false }) label!: boolean;
  @Prop({ default: '' }) selectedItem!: string;
  @Prop({ default: null }) selectedData!: object;
  @Prop({ default: false }) disabled!: boolean;
  @Prop({ default: () => {
      return ['name'] 
  }}) searchTargets!: Array<any>;

  // DATA
  selectedOptionsModel: string = '';
  selectedDataModel: any = null;
  searchValue: string = ""
  search: object = search;
  dropdown: boolean = false;
  inputFocus: boolean = false;

  // COMPUTED
  get selectClass() {
    let value = 'dean-select';
    if (this.small == true) value += ` small`;
    if (this.number == true) value += ` number`;
    if (this.fillWidth == true) value += ` fill-width`;
    return value;
  }

  get selectedDataClass() {
    if (this.selectedDataModel == {} || this.selectedDataModel == null) {
      return `selected-empty`;
    } else {
      return ``;
    }
  }

  get selectedOptionsClass() {
    if (this.selectedOptionsModel == '') {
      return `selected-empty`;
    } else {
      return ``;
    }
  }

  get searchOptions() {
    let value = this.options
    console.log(this.searchValue)
    if (this.searchValue != "") {
      value = []
      for (const item in this.options) {
        if (this.options[item].toLowerCase().includes(this.searchValue.toLowerCase())) {
          value.push(this.options[item]);
        }
      }
    }

    return value
  }

  get searchData() {
    let value = this.data
    console.log(this.searchValue)
    if (this.searchValue != "") {
      value = []
      for (const item in this.data) {
        if (this.data[item].label.toLowerCase().includes(this.searchValue.toLowerCase())) {
          value.push(this.data[item]);
        }
      }
    }

    return value
  }

  // OPTIONS MODEL
  @Watch('searchValue')
  newSearch() {
    this.dropdown = true
    this.$emit('search', this.searchValue);
    let dql = '';
    if (
      this.searchValue != '' &&
      this.searchValue != null &&
      this.searchValue != undefined
    ) {
      for (const item in this.searchTargets) {
          let value = this.searchValue.split(/[ ,./| ]+/);
          for (const item in value) {
            dql =
              dql +
              this.searchTargets[item].toLowerCase() +
              '=%' +
              encodeURIComponent(value[item]) +
              '%|';
          }
      
      }
    } else {
      this.updateSelectedItem();
      this.updateSelectedData();
    }
    console.log(dql)
    this.$emit('dql', dql);
  }

  @Watch('selectedItem')
  updateSelectedItem() {
    this.selectedOptionsModel = this.selectedItem;
  }

  @Watch('selectedOptionsModel')
  selectedOptionsModelChanged() {
    console.log(this.selectedOptionsModel)
    let data = {
      id: this.id,
      selected: this.selectedOptionsModel
    };

    // if (this.selectedOptionsModel != this.selectedItem) {
    this.$emit('selected-value', data);
    this.dropdown = false
    // }
  }

  @Watch('options')
  updatedOptions() {
    this.updateSelectedItem();
  }

  // DATA MODEL
  @Watch('selectedData')
  updateSelectedData() {
    this.selectedDataModel = this.selectedData;
  }

  @Watch('selectedDataModel')
  selectedDataModelChanged() {
    let data = {
      id: this.id,
      selected: this.selectedDataModel
    };
    console.log(data);
    // if (this.selectedDataModel != this.selectedData) {
    this.$emit('selected-value', data);
    this.dropdown = false
    // }
  }

  @Watch('data')
  updatedData() {
    this.updateSelectedData();
  }

  @Watch('inputFocus')
    inputFocusChanged() {
      if (this.inputFocus == true) {
        this.dropdown = true
      }
    }

  mouseoverDropdown() {
    if (this.inputFocus == true) {
      this.dropdown = true
    }
  }

  // UPDATE ON MOUNTED
  mounted() {
    this.updateSelectedItem();
    this.updateSelectedData();
  }
}
</script>

<style lang="scss" scoped>
// IMPORT
@import '../scss/vars';

.dean-select {
  display: inline-flex;
  position: relative;
  height: 50px;
  //text-transform: lowercase;
  align-content: center;
  justify-content: space-between;
  padding: 5px 10px 5px 10px;

  input {
    display: inline-flex;
    position: absolute;
    display: block;
    height: 40px;
    width: 40px;
    padding: 10px 10px 10px 30px;
    border: 1px solid var(--color-light-shade-1, $color-light-shade-1);
    border-left: 0px;
    background: none;
    @include border-radius(10px 0px 0px 10px);
    z-index: 1;
    cursor: pointer;
    &:focus {
      @include calc('min-width', '100% - 20px');
      @include border-radius(10px);
      padding-left: 35px;
      cursor: default;
      outline: none;
      box-shadow: 0px 0px 10px 2px var(--color-secondary, $color-secondary);
      &:hover {
        background: none;
        cursor: pointer;
      }
    }
    &:hover {
      box-shadow: 0px 0px 10px 2px var(--color-secondary, $color-secondary);
    }

    &:hover ~ .search-icon {
      fill: var(--color-link, $color-link);
      cursor: pointer;
    }
    
    &:focus ~ select,
    &:focus ~ label {
      color: transparent;
    }
  }

  .dropdown {
    position: absolute;
    display: block;
    top: 44px;
    left: 10px;
    background: white;
    border: 1px solid var(--color-light-shade-1, $color-light-shade-1);
    padding: 10px;
    z-index: 960;
    @include border-radius(10px);
    @include calc('width', '100% - 20px');
    @include box-shadow(3px 3px 5px rgba(0, 0, 0, 0.075));
    max-height: 200px;
    overflow-x: hidden;
    overflow-y: auto;

    .dropdown-item {
      padding: 2.5px 5px 2.5px 5px;
      cursor: pointer;
      @include border-radius(5px);
      &:hover {
        background: var(--color-light-shade-1, $color-light-shade-1);
      }
    }

    .disabled {
      color: var(--color-dark-shade-4, $color-dark-shade-4);
      cursor: default;
      &:hover {
        background: white;
      }
    }

    .selected {
      font-weight: 700;
      cursor: default;
      &:hover {
        background: white;
      }
    }
  }

  .search-icon {
    fill: var(--color-dark-shade-4, $color-dark-shade-4);
    position: absolute;
    top: 17.5px;
    left: 22.5px;
    height: 15px;
    width: 15px;
    @include calc(right, '5px + 15px');
    z-index: 0;
    &:hover {
      fill: var(--color-link, $color-link);
      cursor: pointer;
    }
  }

  &:after {
    position: absolute;
    top: 23px;
    content: '';
    right: 20px;
    width: 0px;
    height: 0px;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 4px solid var(--color-dark-shade-4, $color-dark-shade-4);
    background: white;

    /*
    &:after {
      position: absolute;
      top: 15px;
      right: 14px;
      width: 20px;
      height: 20px;
      background: white;
      opacity: .75;
      @include border-radius(2.5px);
    }
    */
  }

  select {
    display: inline-flex;
    align-self: center;
    justify-self: center;
    vertical-align: center;
    text-align-last: center;
    max-width: 150px;
    height: 40px;
    cursor: pointer;
    margin: 0;
    border: 1px solid var(--color-light-shade-2, $color-light-shade-2);
    background: white;
    @include border-radius(10px 10px 10px 10px);
    padding: 10px 10px 10px 50px;
    @include transition(all ease 0.4s);
    &:hover {
      outline: none;
      box-shadow: 0px 0px 10px 2px var(--color-secondary, $color-secondary);
    }
    &:hover ~ input {
      box-shadow: none;
      background: red;
    }
    &:disabled {
      color: var(--color-dark-shade-4, $color-dark-shade-4);
      font-weight: 500;
      cursor: not-allowed;
    }
    option:disabled {
      color: var(--color-dark-shade-4, $color-dark-shade-4);
    }
  }

  select::-moz-focus-inner {
    border: 0;
  }

  select::-moz-focus-outer {
    border: 0;
  }

  .selected-empty {
    padding: 10px 10px 10px 50px;
  }

  label {
    @include display-flex;
    align-self: center;
    justify-self: center;
    vertical-align: center;
    color: var(--color-dark-shade-2, $color-dark-shade-2);
  }
}

.dean-select select:hover ~ .dean-select:after {
  border-top: 4px solid var(--color-secondary, $color-secondary);
}


.small {
  height: 30px;
  select {
    margin-left: 5px;
    max-height: 30px;
    padding: 5px 20px 5px 5px;
  }
  &:after {
    top: 13px;
  }
}

.number {
  select {
    width: 75px;
    max-width: 75px;
  }
}

.fill-width {
  width: 100%;
  select {
    text-align-last: left;
    padding: 18px 10px 2px 50px;
    width: 100%;
    max-width: 100%;
    min-height: 40px;
    @include opacity(1, 0.8s);
    @include transition(all ease 0.4s);
    margin: 0px;
  }
  
  .selected-empty {
    padding: 10px 10px 10px 50px;
  }

  label {
    position: absolute;
    top: 10px;
    left: 65px;
    font-size: 7.5pt;
    color: var(--color-dark-shade-4, $color-dark-shade-4);
    @include opacity(1, 0.8s);
    @include transition(all ease 0.4s);
    @include text-select-none();
  }
}
</style>
